import type { ResetPasswordResponse } from '@vy/api-definition';
import { ResetPasswordResponseSchema, type ResetPasswordRequestPayload } from '@vy/api-definition';
import { useMutation, type UseMutationOptions } from 'react-query';
import { getPublicApi } from '../../services/api';

export function useRequestPasswordReset(
  options?: UseMutationOptions<ResetPasswordResponse, unknown, ResetPasswordRequestPayload>,
) {
  return useMutation({
    mutationFn: async ({ email }) => {
      const api = getPublicApi();
      const resetPasswordResponse = await api.resetPassword({
        resetPasswordRequest: { email },
      });

      return ResetPasswordResponseSchema.parse(resetPasswordResponse);
    },
    ...options,
  });
}
